import { types } from 'mobx-state-tree';
import { OrderTotalType } from '../../types/order/OrderTotalClass';

const OrderTotalValue = types.model('OrderTotalValue', {
  class: OrderTotalType,
  name: types.string,
  sort_order: types.number,
  text: types.optional(types.string, ''),
  value: types.number,
});

export default OrderTotalValue;
